import { motion } from "framer-motion";
import { Phone } from "lucide-react";

export const Contact = () => (
  <section id="kontakt" data-testid="contact-section" className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-36">
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="text-center"
    >
      <p className="mb-4 font-display text-xs font-semibold tracking-[0.3em] text-[#E2C792]">
        KONTAKT
      </p>
      <h2 className="mx-auto max-w-2xl font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
        Jeden telefon <span className="text-[#E2C792]">i jedziemy</span>
      </h2>
      <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-white/60">
        Zadzwoń, aby zamówić przejazd, zapytać o cenę lub ustalić szczegóły.
        Jesteśmy do dyspozycji 7 dni w tygodniu — przejazdy na lotnisko
        również w nocy, po wcześniejszej rezerwacji.
      </p>

      <a
        href="tel:+48737473050"
        data-testid="contact-phone-button"
        className="group mt-12 inline-flex flex-col items-center gap-5"
      >
        <span className="inline-flex h-20 w-20 items-center justify-center rounded-full border border-[#E2C792]/40 bg-[#E2C792]/10 text-[#E2C792] transition-transform duration-300 group-hover:scale-110">
          <Phone className="h-9 w-9" strokeWidth={1.8} />
        </span>
        <span className="font-display text-5xl font-extrabold tracking-tight text-white transition-colors duration-300 group-hover:text-[#E2C792] sm:text-6xl md:text-7xl">
          737 473 050
        </span>
        <span className="rounded-full border border-white/20 px-6 py-2.5 font-display text-xs font-semibold tracking-[0.2em] text-white/60 transition-colors duration-300 group-hover:border-[#E2C792]/50 group-hover:text-[#E2C792]">
          KLIKNIJ, ABY ZADZWONIĆ
        </span>
      </a>
    </motion.div>
  </section>
);
